import React from "react";
import { useForm,Controller } from "react-hook-form";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { yupResolver } from "@hookform/resolvers/yup";
import { FormError } from "../../components/FormError";
import * as Yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import  defaultConfig  from "../../config/Config"
import SelectBox from "../../components/admin/SelectBox";
import {getProductById, resetApiStatus, saveDetails} from "../../slices/ProductsSlice";
import { Loading } from "../../components/Loading";
import { MessageModel } from "../../components/MessageModel";
//import { VendorDropDown } from "../../components/admin/user/VendorDropDown";
import { useEffect, useState } from "react";
import { getAllState, getBrands, getCatList, getSubCategoriesList } from "../../slices/InitialDataSlice";
import { CamelToSentanceCase } from "../../Utils/utils/CommanFnc";
import NumberField  from "../../components/admin/NumberField";

export function AddProducts() {
  const locationData = useLocation()
  const params = useParams()
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const success = useSelector((state) => state.products.success);
  const message = useSelector((state) => state.products.message);
  const loading = useSelector((state) => state.products.loading);
  const productData = useSelector((state) => state.products.editData);
  const categories = useSelector((state) => state.initialData.categories);
  const subCategories = useSelector((state) => state.initialData.subCategories);
  const brands = useSelector((state) => state.initialData.brands);
  const allState = useSelector((state) => state.initialData.StateList)
  const [coupon] = useState();
  const [cateList, setCateList] = useState([]);
  const [brandList, setBrandList] = useState([]);
  const [subCatList, setSubCatList] = useState([]);
  const [stateList, setStateList] = useState([]);
  const [statePrice, setStatePrice] = useState([]);
  const formSchema = Yup.object().shape({
    name: Yup.string().required("Please enter product name"),
    quantity: Yup.number()
              .typeError("Please enter valid number")
              .min(1, "Minimum quantity should be 1."),
    price: Yup.number()
              .typeError("Please enter valid price")
              .min(1, "Minimum price should be 1."),
    category: Yup.string().required("Please select product category"),
    brandId: Yup.string().required("Please select product brand"),
    subCategory: Yup.string().required("Please select product sub category")
    // .concat(!coupon ? Yup.string().required('Please select category') : null)    
  });
  const {
    register,
    handleSubmit,
    setValue,
    control,    
    formState: { errors },
  } = useForm({
    mode: "onBlur",
    resolver: yupResolver(formSchema),
  });

  async function onSubmit(data){
    
    const statePrice = data.statePrice.filter( ( item ) => item.price !== '' )
    data.statePrice = statePrice
    dispatch(saveDetails(data))
  };

  function onSelectCategory(value, callBack) {
    dispatch(getSubCategoriesList({catId: value}));
    if(typeof callBack === "function")
      callBack(value); 
  }

  function onCancel() {
    const queryString  = locationData.state? new URLSearchParams(locationData.state).toString(): null
    let url = '/products'
    if(queryString) {
      url = url  + `?${queryString}`
    }
    navigate(url)
  }

  function onBrandChange(value, callBack) {
    dispatch( getCatList({type:"product", brandId: value}) )
    if(typeof callBack === "function")
      callBack(value);
  }

  useEffect(() => { 

    dispatch(getAllState())

  }, [dispatch])

  useEffect(() => { 
    setStateList(allState)
  }, [allState])

  useEffect(() => {
    if(params.id){
      dispatch(getProductById(params.id))
    }
  }, [dispatch, navigate, params.id])
  
  useEffect(() => {

    if(productData && params.id){
      setStatePrice(productData.statePrice)
      for( let key in productData ){
        if( key !== "statePrice"){
          setValue(key, productData[key])
        }
      }
      setValue('id', params.id)
      if(productData.brandId)
        onBrandChange(productData.brandId)

      if(productData.category)
        onSelectCategory(productData.category)

    }

  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params.id, productData])

  useEffect(()=>{
    if(typeof categories === "object"){
      let list = []
      list = categories?.map( ({_id, name}) => { return {label: name, value: _id} } )  
      setCateList(list)
    }
    
    if(subCategories){
      let list = []
      list = subCategories?.map( ({_id, name}) => { return {label: name, value: _id} } )  
      setSubCatList(list)
    }

    if(brands) {
      let list = brands?.map( ({_id, name}) => { return {label: name, value: _id }} );
      setBrandList( list )
    }
    
  },[brands, categories, subCategories])

  useEffect( () => {
    dispatch( getBrands() )
  },[dispatch])

  function findStatePrice(state, index) {
    const existsData = statePrice?.find( ( item ) => item.stateId === state._id)
    if (existsData) {
      //setValue(`statePrice.${index}.price`, existsData.price)  
      return  (
            <>
              <input type="hidden" className="form-control" {...register(`statePrice.${index}._id`)} value={existsData._id} />    
              <input type="hidden" className="form-control" {...register(`statePrice.${index}.stateId`)} value={state._id} />
              <NumberField setValue = { setValue } control = {control} name = {`statePrice.${index}.price`} className='input-txt form-control' value={existsData.price} />  
            </>
        )
    } else {
      return  (
        <>
          <input type="hidden" className="form-control" {...register(`statePrice.${index}.stateId`)} value={state._id} />
          <NumberField control = {control} setValue = { setValue } name = {`statePrice.${index}.price`} className='input-txt form-control' value='' />  
        </>
    )

    }

  }

  return (
    <div className="row">
      <div className="col-md-12 col-lg-12">
        <div className="card payment-card">
          <div className="card-header">
            <h4 className="card-title">{ coupon? "Edit Product Details": "Create Product"}</h4>
          </div>
          <hr/>
          <div className="card-body">
            <form onSubmit={handleSubmit(onSubmit)}>
              <input {...register("id")} type="hidden" />
              {
                coupon?<input
                    {...register("_id")}
                    type="hidden"
                    className={`input-txt form-control`}
                  />:''
              } 
              <div className="formDiv">
                <div className="row">
                  <div className="col-4">
                    <div className="form-group mb-3">
                      <label
                        htmlFor="card-number"
                        className={`input-label ${errors.name && "error"}`}
                      >
                        Name
                      </label>
                      <input
                        {...register("name")}
                        type="text"
                        defaultValue=""
                        id="card-number"
                        placeholder="Name"
                        className={`input-txt form-control ${
                          errors.name && "error"
                        }`}
                      />
                      
                      {errors.name && (
                        <FormError message={errors.name.message} />
                      )}
                    </div>
                  </div>

                  <div className="col-4">
                    <div className="form-group mb-3">
                      <label
                        htmlFor="card-number"
                        className={`input-label ${errors.quantity && "error"}`}
                      >
                        Quantity
                      </label>
                      <input
                        {...register("quantity")}
                        type="number"
                        min="1"
                        className={`input-txt form-control ${
                          errors.quantity && "error"
                        }`}
                        placeholder="Product Quantity"
                      />
                      {errors.quantity && (
                        <FormError message={errors.quantity.message} />
                      )}
                    </div>
                  </div>

                  <div className="col-4">
                    <div className="form-group mb-3">
                      <label
                        htmlFor="card-number"
                        className={`input-label ${errors.price && "error"}`}
                      >
                        Default Price
                      </label>
                     
                      <NumberField placeholder="Product Price" setValue = { setValue } control = {control} name = {`price`} className='input-txt form-control' value={`${productData.price || 0}`} />  
                      {errors.price && (
                        <FormError message={errors.price.message} />
                      )}
                    </div>
                  </div>
                  <div className="col-4">
                    <div className="form-group mb-3">
                      <label
                        htmlFor="card-number"
                        className={`d-block ${errors.statue && "error"}`}
                      >
                        Unit
                      </label>
                      <Controller
                        control={control}
                        name="unit"
                        render={({ field: { value, onChange } }) => (
                          <SelectBox
                            options={defaultConfig.unitList}
                            isClearable={true}
                            onChange={(opt) => onChange(opt?.value)}
                            value={defaultConfig.unitList.find(
                              (option) => option.value === value
                            )}
                          />
                        )}
                      />
                      {errors.status && (
                        <FormError message={errors.status.message} />
                      )}
                    </div>
                  </div>
                  <div className="col-4">
                    <div className="form-group mb-3">
                      <label
                        htmlFor="card-number"
                        className={`d-block ${errors?.brandId?.message && "error"}`}>
                        Brand
                      </label>
                            <Controller
                              control={control}
                              name="brandId"
                              //value={defaultConfig.status[0]["value"]}
                              //defaultValue={defaultConfig.status[0]["value"]}
                              render={({ field: { value, onChange } }) => (
                                <SelectBox
                                  options={brandList}
                                  isClearable={true}
                                  onChange={(opt) =>  onBrandChange(opt.value, onChange)}
                                  value={brandList?.find(
                                    (option) => option.value === value
                                  )}
                                />
                              )}
                            />
                            {errors.brandId && (
                              <FormError message={errors.brandId.message} />
                            )}
                    </div>
                  </div>
                  
                  <div className="col-4">
                    <div className="form-group mb-3">
                      <label
                        htmlFor="card-number"
                        className={`d-block ${errors?.category?.message && "error"}`}
                      >
                        Category
                      </label>
                            <Controller
                              control={control}
                              name="category"
                              
                              //value={defaultConfig.status[0]["value"]}
                              //defaultValue={defaultConfig.status[0]["value"]}
                              render={({ field: { value, onChange } }) => (
                                <SelectBox
                                  options={cateList}
                                  isClearable={true}
                                  onChange={(opt) => onSelectCategory(opt?.value, onChange)}
                                  value={cateList.find(
                                    (option) => option.value === value
                                  )}
                                />
                              )}
                            />
                            {errors.category && (
                              <FormError message={errors.category.message} />
                            )}``
                    </div>
                  </div>

                  <div className="col-4">
                    <div className="form-group mb-3">
                      <label
                        htmlFor="card-number"
                        className={`d-block ${errors?.category?.message && "error"}`}
                      >
                        Sub Category
                      </label>
                            <Controller
                              control={control}
                              name="subCategory"
                              
                              //value={defaultConfig.status[0]["value"]}
                              //defaultValue={defaultConfig.status[0]["value"]}
                              render={({ field: { value, onChange } }) => (
                                <SelectBox
                                  options={subCatList}
                                  isClearable={true}
                                  onChange={(opt) =>  onChange(opt?.value) }
                                  value={subCatList?.find(
                                    (option) => option.value === value
                                  )}
                                />
                              )}
                            />
                            {errors.category && (
                              <FormError message={errors.category.message} />
                            )}``
                    </div>
                  </div>

                  <div className="col-4">
                    <div className="form-group mb-3">
                      <label
                        htmlFor="card-number"
                        className={`d-block ${errors.statue && "error"}`}
                      >
                        Status
                      </label>
                      <Controller
                        control={control}
                        name="status"
                        value={defaultConfig.status[0]["value"]}
                        defaultValue={defaultConfig.status[0]["value"]}
                        render={({ field: { value, onChange } }) => (
                          <SelectBox
                            options={defaultConfig.status}
                            isClearable={true}
                            onChange={(opt) => onChange(opt?.value)}
                            value={defaultConfig.status.find(
                              (option) => option.value === value
                            )}
                          />
                        )}
                      />
                      {errors.status && (
                        <FormError message={errors.status.message} />
                      )}
                    </div>
                  </div>
              
                </div>

                <div className="row">
                  <div className="col-md-12">
                    <h3> State Wise Price </h3>
                    <hr/>
                  </div>
                  {
                    stateList.map((state, index) => {
                      return  (
                      <div key={index} className="col-md-3">
                        <label className="form-label">{CamelToSentanceCase(state.name)}</label>
                        {  findStatePrice(state, index) }
                        
                      </div>)
                    })
                  }
                </div>
              </div>
              <div className="col-12 mt-5 mb-3 text-right">
                <button type="submit" className="btn btn-outline-success btn-lg mx-2">
                  Submit
                </button>
                <button type="button" onClick={onCancel} className="btn btn-outline-danger btn-lg mx-2">
                  Cancel
                </button>
              </div>
            </form>
          </div>
          
        </div>
      </div>
      {loading === true?<Loading/>:"" }
      {message? 
        <MessageModel
          btnEvent={ ()=>{
            dispatch(resetApiStatus()) 
            if(success) 
              navigate("/products")
          } }
          success={success}
          message={message}
        />
      :""}
    </div>
  );
}
